var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticStyle:{"font-weight":"700"}},[_vm._v("欢迎使用 宇航物流管理平台")]),_c('div',{staticStyle:{"margin-top":"8px","color":"#64748b"}},[_vm._v("左侧进入：订单管理 / 机场管理 / 系统管理")])])
}
var staticRenderFns = []

export { render, staticRenderFns }